import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const EditCarousel = () => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [type, setType] = useState("image");
  const [imageUrls, setImageUrls] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [link, setLink] = useState();
  const { id } = useParams();
  const [previewUrls, setPreviewUrls] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleCancel = () => {
    navigate("/admin/carousel");
  };

  const handleFileChange = async (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setPreviewUrls((prevUrls) => {
        const newUrls = [...prevUrls];
        newUrls[index] = previewUrl;
        return newUrls;
      });

      setSelectedFiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles[index] = file;
        return newFiles;
      });

      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(`/api_w/upload/multiple`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });

        const uploadedImageUrl = response.data.data[0]?.Location;
        if (uploadedImageUrl) {
          setImageUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls[index] = uploadedImageUrl;
            return newUrls;
          });
        } else {
          toast.error("Error: Unable to retrieve image URL from response.");
        }
      } catch (error) {
        toast.error(
          "Error Upload Gambar: " +
            (error.response?.data?.message || error.message)
        );
      }
    }
  };

  useEffect(() => {
    const fetchCarouselData = async () => {
      try {
        const response = await axios.get(`/api_w/carousels/${id}`, {
          headers: {
            db_name: process.env.REACT_APP_DB_NAME,
          },
        });
        const carousel = response.data.data;
        setTitle(carousel.title);
        setType(carousel.type);
        const urls = carousel.url ? carousel.url.split(",") : [];
        if (urls.length < 2) {
          urls.push("");
        }
        setImageUrls(urls);
        setPreviewUrls(urls);
        setVideoUrl(carousel.type === "video" ? carousel.url : "");
        setLink(carousel.link);
      } catch (error) {
        toast.error(
          "Error fetching carousel data" +
            (error.response?.data?.message || error.message)
        );
      }
    };

    fetchCarouselData();
  }, [id]);

  const handleSubmit = async () => {
    try {
      const url = type === "image" ? imageUrls : videoUrl;
      const response = await axios.put(
        `/api_w/carousels/${id}`,
        {
          title,
          url,
          type,
          link,
        },
        {
          headers: {
            Authorization: `${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
            db_name: process.env.REACT_APP_DB_NAME,
          },
        }
      );
      console.log(response.data);
      toast.success("Berhasil Edit Carousel!");
      navigate("/admin/carousel");
    } catch (error) {
      toast.error(
        "Error Edit Carousel: " +
          (error.response?.data?.message || error.message)
      );
    }
  };

  return (
    <div className="mt-5 px-2">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Edit Carousel</h2>
        <p className="text-sm text-gray-500 mt-1">Perbarui data banner carousel</p>
      </div>
      <div className="rounded-2xl bg-white shadow-sm p-6 dark:bg-navy-700 space-y-5">
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Judul</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)}
            className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
            placeholder="Judul carousel" required
          />
        </div>
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Tipe</label>
          <select value={type} onChange={(e) => setType(e.target.value)}
            className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
          >
            <option value="image">Gambar</option>
            <option value="video">Video</option>
          </select>
        </div>
        {type === "image" ? (
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Gambar</label>
            <div className="mt-2 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {previewUrls.map((url, index) => (
                <div key={index} className="relative flex h-44 items-center justify-center overflow-hidden rounded-xl border-2 border-dashed border-gray-200 bg-gray-50 cursor-pointer hover:border-brand-400 transition-colors">
                  {url ? (
                    <img src={url} alt="preview" className="h-full w-full object-cover" />
                  ) : (
                    <div className="text-center px-4">
                      <svg className="mx-auto h-8 w-8 text-gray-300 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>
                      <p className="text-xs text-gray-400">{index === 0 ? "Desktop (landscape)" : "Mobile (portrait)"}</p>
                    </div>
                  )}
                  <input type="file" accept="image/*" className="absolute inset-0 opacity-0 cursor-pointer" onChange={(e) => handleFileChange(e, index)} />
                </div>
              ))}
            </div>
            <p className="mt-1.5 text-xs text-gray-400">*Max 5MB — .png, .jpg, .jpeg, .svg, .webp</p>
          </div>
        ) : (
          <div>
            <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">URL Video (YouTube / Google Drive)</label>
            <input type="text" value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)}
              className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </div>
        )}
        <div>
          <label className="mb-1.5 block text-sm font-semibold text-navy-700 dark:text-white">Link (opsional)</label>
          <input type="url" value={link || ""} onChange={(e) => setLink(e.target.value)}
            className="block w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-2.5 text-sm text-gray-700 outline-none focus:border-brand-500 focus:ring-1 focus:ring-brand-500"
            placeholder="https://..."
          />
        </div>
        <div className="flex justify-end gap-3 pt-2">
          <button type="button" onClick={handleCancel}
            className="rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-medium text-gray-600 hover:bg-gray-50 transition-colors"
          >
            Batal
          </button>
          <button type="button" onClick={handleSubmit}
            className="rounded-xl px-6 py-2.5 text-sm font-bold text-white shadow-sm transition-colors"
            style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
          >
            Simpan Perubahan
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditCarousel;
